import {
  MainButton,
  QuitLink,
  SecondaryButton,
  Title,
} from '../../styles/GlobalStyledComponents';
import ImageSrc from '../../assets/images/quit/quitImg.svg';
import { QuitImage } from './QuitStyledComponents';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PostMessageService, { BannerOutcome } from '../../services/PostMessage';
import ViewModeService from '../../services/ViewMode';
import { useEffect, useState } from 'react';
import { useWebsocket } from './../../contexts/WebsocketContext/websocket-context.hook';
import CustomerDeviceService from '../../services/CustomerDevice';
import AnalyticsService from '../../services/Analytics';
import AnalyticsHelper from '../../utils/analyticsHelper';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext/creditProposalResult-hook';
import CreditProposalService from '../../services/CreditProposal';
import { ROUTES_PATH } from '../../constants';
import InsightService from '../../services/Insight';
import { useMerchant } from '../../contexts/MerchantContext';

export const Quit = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isCounterOffer = searchParams.get('isCounterOffer');

  const { creditProposalResult, createCreditProposalResult } =
    useCreditProposalResult();

  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);
  const { deleteWebsocketTexts } = useWebsocket();
  const location = useLocation();

  const handleContinue = () => {
    navigate(-1);
  };

  const handleClose = async () => {
    if (isCounterOffer && creditProposalResult) {
      PostMessageService.BannerOutcome(
        BannerOutcome.COUNTER_OFFER_REJECTED,
        { proposalId: creditProposalResult.credit_proposal_id }
      );
      navigate(ROUTES_PATH.CANCEL);
    } else {
      const step_number = AnalyticsHelper.getStepLocation(location.pathname);
      AnalyticsService.sendBackExit(step_number);
      if (CustomerDeviceService.getCustomerDevice()) {
        window.location.href = 'https://pepperfinance.es/';
      } else {
        if (isApp && device === 'android') {
          window.location.href = 'peppermerchants://home';
        } else {
          deleteWebsocketTexts();
          PostMessageService.closeCEX();
        }
      }
    }
  };

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  return (
    <>
      {isCounterOffer &&
        <Title id="quit-title">¿Seguro que quieres rechazar el planteamiento ofrecido?</Title>
      }
      {!isCounterOffer &&
        <Title id="quit-title">¿Seguro que quieres abandonar el proceso?</Title>
      }
      <QuitImage src={ImageSrc} />
      <MainButton id="quit-continue-btn" onClick={handleContinue}>
        Continuar
      </MainButton>
      {isCounterOffer &&
        <SecondaryButton id="quit-cancel-btn" onClick={handleClose}>
          Rechazar
        </SecondaryButton>
      }
      {!isCounterOffer && isApp && device === 'ios' &&
        <QuitLink href="peppermerchants://home">Abandonar</QuitLink>
      }
      {!isCounterOffer && (!isApp || device !== 'ios') &&
        <SecondaryButton id="quit-cancel-btn" onClick={handleClose}>
          Abandonar
        </SecondaryButton>
      }
    </>
  );
};
